<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="Weight"
      :label="$t('kiosk.weight')"
      label-for="Weight"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.weight')"
        rules="required|between:15,200"
        #default="{ errors }"
      >
        <b-input-group
          append="kg"
          class="input-group-merge"
        >
          <b-form-input
            id="Weight"
            :value="form.Weight"
            @input="v => { form.Weight = v; emitFormData() }"
          />
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";

export default {
  name: "NwFormWeight",
  mixins: [nwFormTaskTypeMixin],
}
</script>

<style scoped>

</style>